import mitt from 'mitt';

import type { useDerivedActionStateEvents } from './useDerivedActionStateEmitter.types';

export const useDerivedActionStateEmitter = mitt<useDerivedActionStateEvents>();
